/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 参数日志类型
 */
let EnumParamsLogType = {
	StatusParams: 						new EnumItem('状态参数 ', 1),
    KeyParams: 						new EnumItem('关键参数', 2),
	...enumMixn
}
export default EnumParamsLogType
